import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/BannerSection.scss';

const BannerSectionSkeleton = () => {
  return (
    <section className="banner-section">
      <div className="banner-overlay"></div>
      <video className="banner-video" style={{ display: 'none' }}></video>
      <div className="banner-content">
        <button className="banner-play-btn" disabled>
          <span className="banner-play-outer">
            <span className="banner-play-inner">
              <svg width="32" height="32" viewBox="0 0 32 32">
                <polygon points="12,8 26,16 12,24" fill="#fff" />
              </svg>
            </span>
          </span>
        </button>
      </div>
    </section>
  );
};

export default BannerSectionSkeleton;
